import React from "react";
import { Formik, Form } from "formik";
import Model from "../Model";
import tw from "tailwind-styled-components";
import { SideCancelBtn, SubmitBtn } from "../Styles/InputStyles";

const ConfirmPublish = ({
    setIsPublishMenu,
    selectedData,
    publishMenuLoading,
    publishMenuMutate,
    propId,
    data
}) => {
    const isPublished = data?.status === 1;
    const actionText = isPublished ? "unpublish" : "publish";
    const statusToUpdate = isPublished ? 0 : 1;

    const handleConfirm = () => {
        publishMenuMutate({
            propId,
            status: statusToUpdate,
        });
    };

    return (
        <Model
            width="w-full max-w-md"
            setOpenModel={setIsPublishMenu}
            title={`Confirm ${actionText}`}
        >
            <WarningText>
                {isPublished
                    ? "Are you sure you want to unpublish this menu? It will no longer be visible to tenants."
                    : "Are you sure you want to publish this menu? It will become visible to tenants."
                }
            </WarningText>

            <div className="w-full flex justify-between space-x-6 my-4">
                <SideCancelBtn
                    type="button"
                    onClick={() => setIsPublishMenu(false)}
                >
                    Cancel
                </SideCancelBtn>
                <SubmitBtn
                    onClick={handleConfirm}
                    disabled={publishMenuLoading}
                    className="border border-primary-color bg-white text-primary-color hover:bg-primary-color hover:text-white"
                >
                    {publishMenuLoading ? "Processing..." : `Confirm ${actionText}`}
                </SubmitBtn>
            </div>
        </Model>
    );
};

const WarningText = tw.p`text-gray-500 text-base mb-4`;

export default ConfirmPublish;